var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
/**
 * Detects if we're being rendered inside a shadow DOM.
 */
export function useDetectShadowDom() {
    var _a = __read(useState(null), 2), el = _a[0], setEl = _a[1];
    var shadowDomInfo = useMemo(function () {
        var result = {
            adoptedStyleSheets: undefined,
            isDone: false,
            shadowRoot: undefined,
        };
        if (!el)
            return result;
        result.isDone = true;
        // In case `ShadowRoot` isn't defined (e.g., in SSR or a test suite).
        if (typeof ShadowRoot === 'undefined' || !ShadowRoot)
            return result;
        var rootNode = el.getRootNode();
        if (!(rootNode instanceof ShadowRoot))
            return result;
        result.shadowRoot = rootNode;
        result.adoptedStyleSheets = rootNode.adoptedStyleSheets;
        return result;
    }, [el]);
    return __assign({ detectorNode: _jsx("div", { "data-hawkins-shadow-dom-detector": true, ref: setEl, style: { display: 'none' } }) }, shadowDomInfo);
}
useDetectShadowDom.displayName = 'useDetectShadowDom';
//# sourceMappingURL=useDetectShadowDom.js.map